{
    "(save {highestYearlyDiscount}%)": "(oszczędzasz {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dni za darmo",
    "{amount} off": "Rabat {amount}",
    "{amount} off for first {number} months.": "Rabat {amount} na pierwsze {number} miesiące.",
    "{amount} off for first {period}.": "Rabat {amount} na pierwszy {period}.",
    "{amount} off forever.": "Rabat {amount} na zawsze",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Rabat {discount}%",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} nie będzie już otrzymywać newslettera {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} nie będzie już otrzymywać wiadomości, gdy ktoś odpowie na Twój komentarz.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} nie będzie już otrzymywać newslettera.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} darmowych dni",
    "{years} years": "",
    "+1 (123) 456-7890": "+48 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "Szczegóły konta zostały pomyślnie zaktualizowane",
    "Account settings": "Ustawienia konta",
    "Add a personal note": "Dodaj osobistą notatkę",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Po zakończeniu okresu próbnego zostanie naliczona regularna opłata za wybrany poziom subskrypcji. Pamiętaj, że możesz anulować subskrypcję zanim to nastąpi.",
    "Already a member?": "Masz już konto?",
    "An error occurred": "Wystąpił błąd",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie lub jeśli błąd będzie nadal występował, to <a>skontaktuj z pomocą techniczną</a>.",
    "Back": "Wstecz",
    "Back to Log in": "Wróć do logowania",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Cancel anytime.": "Anuluj w dowolnym momencie.",
    "Cancel subscription": "Anuluj subskrypcję",
    "Canceled": "",
    "Cancellation reason": "Powód anulowania",
    "Change": "Zmień",
    "Change plan": "Zmień plan",
    "Check spam & promotions folders": "Sprawdź foldery spamu i promocji",
    "Check with your mail provider": "Skontaktuj się z dostawcą poczty elektronicznej",
    "Check your inbox to verify email update": "Sprawdź skrzynkę odbiorczą, aby zweryfikować aktualizację adresu e-mail",
    "Choose": "Wybierz",
    "Choose a different plan": "Wybierz inny plan",
    "Choose a plan": "Wybierz plan",
    "Choose a tier": "",
    "Choose your newsletters": "Wybierz swoje newslettery",
    "Click here to retry": "Kliknij tu żeby potwierdzić",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zamknij",
    "Code": "",
    "Comment preferences updated.": "Zaktualizowano preferencje dotyczące komentarzy.",
    "Comments": "Komentarze",
    "Complimentary": "Za darmo",
    "Confirm": "Potwierdź",
    "Confirm cancellation": "Potwierdź rezygnację",
    "Confirm subscription": "Potwierdź subskrypcję",
    "Contact support": "Kontakt z pomocą techniczną",
    "Continue": "Kontynuuj",
    "Continue subscription": "Kontynuuj subskrypcję",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Nie można utworzyć sesji rozliczeniowej Stripe",
    "Could not sign in. Login link expired.": "Nie można się zalogować, ponieważ link do logowania wygasł.",
    "Could not update email! Invalid link.": "Nie można zaktualizować adresu email, ponieważ link jest nieprawidłowy.",
    "Create a new contact": "Utwórz nowy kontakt",
    "Current plan": "Obecny plan",
    "Delete account": "Skasuj konto",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Nie chcesz tego robić? Zarządzaj preferencjami <button>tutaj</button>.",
    "Don't have an account?": "Nie masz jeszcze konta?",
    "Edit": "Edytuj",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them now": "",
    "Email newsletter": "Newsletter email",
    "Email newsletter settings updated": "Zaktualizowano ustawienia newslettera email",
    "Email preferences": "Ustawienia email",
    "Email preferences updated.": "Zaktualizowano preferencje email.",
    "Emails": "Emaile",
    "Emails disabled": "Wysyłanie emaili zablokowane",
    "Ends {offerEndDate}": "Kończy się {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Wpisz swój adres email",
    "Enter your name": "Wpisz swoje imię",
    "Error": "Błąd",
    "Expires {expiryDate}": "Wygasa {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Nie udało się anulować subskrypcji. Spróbuj ponownie",
    "Failed to log in, please try again": "Nie udało się zalogować, spróbuj ponownie",
    "Failed to log out, please try again": "Nie udało się wylogować, spróbuj ponownie",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Nie udało się przetworzyć transakcji, spróbuj ponownie",
    "Failed to send magic link email": "Nie udało się wysłać wiadomości email z magicznym linkiem",
    "Failed to send verification email": "Nie udało się wysłać emaila weryfikacyjnego",
    "Failed to sign up, please try again": "Nie udało się zarejestrować, spróbuj ponownie",
    "Failed to update account data": "Nie udało się zaktualizować danych konta",
    "Failed to update account details": "Nie udało się zaktualizować szczegółów konta",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Nie udało się zaktualizować ustawień newslettera",
    "Failed to update subscription, please try again": "Nie udało się zaktualizować subskrypcji. Spróbuj ponownie",
    "Failed to verify code, please try again": "",
    "Forever": "Na zawsze",
    "Free Trial – Ends {trialEnd}": "Bezpłatny okres próbny - Koniec {trialEnd}",
    "From": "",
    "Get help": "Uzyskaj pomoc",
    "Get in touch for help": "Skontaktuj się, aby uzyskać pomoc",
    "Get notified when someone replies to your comment": "Otrzymaj powiadomienie, gdy ktoś odpowie na Twój komentarz",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Oceń ten wpis",
    "Help! I'm not receiving emails": "Pomocy! Nie otrzymuję wiadomości e-mail",
    "Here are a few other sites you may enjoy.": "Oto kilka innych witryn, które mogą Ci się spodobać.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Jeśli newsletter zostanie oznaczony przez Ciebie jako spam, przesyłanie dalszych wiadomości email jest wyłączane dla tego adresu.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Jeśli skarga dotycząca spamu była przypadkowa lub chcesz ponownie zacząć otrzymywać wiadomości, możesz raz jeszcze zasubskrybować, klikając przycisk na poprzednim ekranie.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Jeśli anulujesz subskrypcję teraz, będziesz mieć do niej dostęp do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Jeśli masz firmowy adres e-mail lub konto w domenie publicznej, skontaktuj się z działem IT i poproś o zezwolenie na odbieranie wiadomości od {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Link do logowania został wysłany do Twojej skrzynki odbiorczej. Jeśli nie dotrze w ciągu 3 minut, sprawdź folder spam.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Jeśli chcesz ponownie zacząć otrzymywać wiadomości, najlepiej sprawdź poprawność swojego adres email, a następnie kliknij przycisk ponownej subskrypcji na poprzednim ekranie.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Jeśli nie otrzymujesz subskrybowanego newslettera, oto kilka rzeczy do sprawdzenia.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Jeśli wykonałeś wszystkie te czynności i nadal nie otrzymujesz wiadomości, możesz skontaktować się z pomocą techniczną pod tym adresem {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "W przypadku trwałych problemów podczas wysłania newslettera, wiadomości email zostaną wyłączone na koncie.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "W kliencie poczty dodaj {senderEmail} do listy kontaktów. Sygnalizuje to dostawcę poczty, że wiadomości wysyłane z tego adresu powinny być zweryfikowane.",
    "Invalid email address": "Nieprawidłowy adres e-mail",
    "Invalid verification code": "",
    "Jamie Larson": "Jan Kowalski",
    "jamie@example.com": "jan.kowalski@example.com",
    "Less like this": "Mniej podobnych",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Upewnij się, że emaile nie trafiają przypadkowo do folderów spam w skrzynce odbiorczej. Jeśli tak jest, kliknij na \"Oznacz jako nie spam\" i/lub \"Przenieś do skrzynki odbiorczej\".",
    "Manage": "Zarządzaj",
    "Maybe later": "Może później",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Członkostwo z tej domeny email jest obecnie ograniczone.",
    "Memberships unavailable, contact the owner for access.": "Dostęp niemożliwy, skontaktuj się z właścicielem strony w celu uzyskania dostępu.",
    "month": "miesiąc",
    "Monthly": "Miesięcznie",
    "More like this": "Więcej podobnych",
    "More options": "",
    "Name": "Imię",
    "Need more help? Contact support": "Potrzebujesz pomocy? Skontaktuj się z pomocą techniczną",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newslettery mogą zostać wyłączone na Twoim koncie z dwóch powodów: poprzedni email został oznaczony jako spam lub próba wysłania wiadomości zakończyła się niepowodzeniem (odesłaniem).",
    "No member exists with this e-mail address.": "Nie istnieje żaden użytkownik o tym adresie e-mail.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nie dostajesz emaili?",
    "Now check your email!": "Teraz sprawdź swoją pocztę!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Po ponownym zapisaniu się, jeśli nadal nie widzisz wiadomości e-mail w skrzynce odbiorczej, sprawdź folder ze spamem. Niektórzy dostawcy skrzynek odbiorczych przechowują rejestr poprzednich skarg na spam i będą nadal oznaczać wiadomości e-mail flagami. Jeśli tak się stanie, oznacz najnowszy newsletter jako „To nie jest spam”, aby przenieść go z powrotem do głównej skrzynki odbiorczej.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Trwała awaria (odesłanie emaila)",
    "Phone number": "Numer telefonu",
    "Plan": "Plan",
    "Plan checkout was cancelled.": "Opłata za plan została anulowana.",
    "Plan upgrade was cancelled.": "Aktualizacja planu została anulowana.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Wyślij maila pod adres {supportAddress}, aby dostosować bezpłatną subskrypcję.",
    "Please enter {fieldName}": "Proszę wypełnić {fieldName}",
    "Please fill in required fields": "Wypełnij wymagane pola",
    "Podcasts": "",
    "Re-enable emails": "Włącz ponownie emaile",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Rekomendacje",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Odnowi się w cenie {price}.",
    "Resume subscription": "",
    "Retry": "Powtórz",
    "Save": "Zapisz",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Wysyłanie linku do logowania...",
    "Sending...": "Wysyłanie...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Pokaż wszystko",
    "Sign in": "Zaloguj się",
    "Sign out": "Wyloguj się",
    "Sign up": "Zarejestruj się",
    "Signup error: Invalid link": "Błąd rejestracji: Nieprawidłowy link",
    "Signups from this email domain are currently restricted.": "Rejestracje z tej domeny email są obecnie ograniczone.",
    "Something went wrong, please try again later.": "Wystąpił błąd. Spróbuj ponownie później.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Przepraszamy, w tej chwili nie są dostępne żadne rekomendacje.",
    "Sorry, that didn’t work.": "Przepraszamy, to nie zadziałało.",
    "Spam complaints": "Skargi dotyczące spamu",
    "Start {amount}-day free trial": "Rozpocznij {amount}-dniowy okres próbny",
    "Starting {startDate}": "Rozpoczyna się od {startDate}",
    "Starting today": "Rozpoczyna się od dziś",
    "Submit feedback": "Wyślij ocenę",
    "Subscribe": "Subskrybuj",
    "Subscribed": "Zasubskrybowane",
    "Subscription plan updated successfully": "Plan subskrypcji został pomyślnie zaktualizowany",
    "Success": "Sukces",
    "Success! Check your email for magic link to sign-in.": "Sukces! Sprawdź swój email, aby uzyskać link do logowania.",
    "Success! Your account is fully activated, you now have access to all content.": "Sukces! Twoje konto zostało w pełni aktywowane, masz teraz dostęp do serwisu.",
    "Success! Your email is updated.": "Sukces! Twój email został zaktualizowany.",
    "Successfully unsubscribed": "Wypisanie udane",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Dziękujemy za subskrypcję. Zanim zaczniesz czytać, poniżej znajduje się kilka innych witryn, które mogą Ci się spodobać.",
    "Thank you for your support": "Dziękujemy za Twoje wsparcie",
    "Thank you for your support!": "Dziękujemy za Twoje wsparcie!",
    "Thanks for the feedback!": "Dziękujemy za ocenę!",
    "That didn't go to plan": "Coś poszło nie tak",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Adres email, który mamy to {memberEmail} — jeśli nie jest poprawny, możesz go zaktualizować w swoich <button>ustawieniach konta</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Wystąpił problem z przesyłaniem opinii. Spróbuj ponownie nieco później.",
    "There was an error cancelling your subscription, please try again.": "Wystąpił błąd podczas anulowania subskrypcji. Spróbuj ponownie.",
    "There was an error continuing your subscription, please try again.": "Wystąpił błąd podczas kontynuowania subskrypcji. Spróbuj ponownie.",
    "There was an error processing your payment. Please try again.": "Wystąpił błąd podczas przetwarzania płatności. Spróbuj ponownie.",
    "There was an error sending the email, please try again": "Wystąpił błąd podczas wysyłania wiadomości e-mail. Spróbuj ponownie.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Ta strona posiada zamknięty dostęp. Skontaktuj się z właścicielem, aby uzyskać dostęp.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Ta strona nie przyjmuje obecnie płatności.",
    "This site only accepts paid members.": "Ta strona akceptuje tylko płatne członkostwa.",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Aby dokończyć rejestrację, kliknij w link przesłany na twoją skrzynkę pocztową. Jeśli nie dotrze w ciągu 3 minut, sprawdź folder spamu!",
    "To continue to stay up to date, subscribe to {publication} below.": "Aby być na bieżąco, zasubskrybuj {publication} poniżej.",
    "Too many attempts try again in {number} days.": "Zbyt wiele prób. Spróbuj ponownie za {number} dni.",
    "Too many attempts try again in {number} hours.": "Zbyt wiele prób. Spróbuj ponownie za {number} godzin.",
    "Too many attempts try again in {number} minutes.": "Zbyt wiele prób. Spróbuj ponownie za {number} minut.",
    "Too many different sign-in attempts, try again in {number} days": "Zbyt wiele różnych prób logowania. Spróbuj ponownie za {number} dni",
    "Too many different sign-in attempts, try again in {number} hours": "Zbyt wiele różnych prób logowania. Spróbuj ponownie za {number} godzin",
    "Too many different sign-in attempts, try again in {number} minutes": "Zbyt wiele różnych prób logowania. Spróbuj ponownie za {number} minut",
    "Too many sign-up attempts, try again later": "Zbyt wiele prób rejestracji, spróbuj ponownie później",
    "Try free for {amount} days, then {originalPrice}.": "Wypróbuj za darmo przez {amount} dni, później {originalPrice}.",
    "Unable to initiate checkout session": "Nie można zainicjować sesji realizacji zakupu",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Zostań płatnym subskrybentem i odblokuj dostęp do wszystkich biuletynów.",
    "Unsubscribe from all emails": "Wypisz się w wszystkich emaili",
    "Unsubscribed": "Niezasubskrybowany",
    "Unsubscribed from all emails.": "Anulowano subskrypcję wszystkich emaili.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Wypisanie się z otrzymywania emaili nie powoduje anulowania płatnej subskrypcji {title}",
    "Update": "Zaktualizuj",
    "Update your preferences": "Zaktualizuj preferencje",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link weryfikacyjny został wysłany. Sprawdź skrzynkę odbiorczą.",
    "Verify your email address is correct": "Sprawdź, czy Twój email jest poprawny",
    "Verifying...": "",
    "View plans": "Zobacz plany",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nie udało się wypisać, bo nie znaleziono adresu email. Skontaktuj się w właścicielem strony.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Witamy ponownie, {name}!",
    "Welcome back!": "Witamy ponownie!",
    "Welcome to {siteTitle}": "Witaj w {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Zdarza się, że skrzynka odbiorcza nie akceptuje wiadomości e-mail. W wielu przypadkach może to być tymczasowe, jednak w niektórych przypadkach, szczegolnie gdy adres jest nieprawidłowy lub nie istnieje, ma to charakter trwały.",
    "Why has my email been disabled?": "Dlaczego mój email został zablokowany?",
    "X (Twitter)": "",
    "year": "rok",
    "Yearly": "Rocznie",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Obecnie posiadasz bezpłatny plan, ulepsz do płatnej subskrypcji, aby uzyskać pełny dostęp",
    "You have been successfully resubscribed": "Zostałeś ponownie zapisany",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Obecnie nie otrzymujesz emaili",
    "You're not receiving emails": "Nie otrzymujesz emaili",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Nie otrzymujesz email, ponieważ oznaczono przez Ciebie ostatnią wiadomość jako spam lub nie udało się dostarczyć wiadomości na podany adres email.",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_few": "",
    "You've been gifted a {duration}-month {tierName} membership_many": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Logowanie powiodło się.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Pomyślnie zasubskrybowano <strong>{siteTitle}</strong>",
    "Your account": "Twoje konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Ponowna subskrypcja Twojego emaila nie powiodła się, spróbuj ponownie",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Twoja ocena pomoże nam lepiej kształtować nasze publikacje.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Subskrypcja wygaśnie w dniu {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Subskrypcja zostanie odnowiona w dniu {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Subskrypcja rozpocznie się w dniu {subscriptionStart}"
}
